import axios from '../../plugins/axios.js';
export default{
    async getDirectMails() {
        return await axios.get('/api/DirectMail/GetDirectMailSummary');
    },
    async getDirectMailCampaignCategories(){
        return await axios.get('/api/DirectMail/GetDirectMailCampaignCategories')
    },
    async deleteDirectMail(directMailValues) {
        return await axios.post('/api/DirectMail/DeleteDirectMail', directMailValues);
    },
    async saveDirectMailReport(directMailValues) {
        return await axios.post('/api/DirectMail', directMailValues);
    },
    async getDirectMailID(directMailID){
        return await axios.get(`/api/DirectMail/${directMailID}`)
    },
};
